import React, { useEffect, useRef, useState } from 'react'
import { Button, Header, Input } from '../../components'
import Alert from '../../components/Alert'
import { IoIosSearch } from 'react-icons/io';
import Select from 'react-select';
import { useNavigate } from 'react-router-dom';
import axiosClient from '../../axios-client';
import { useStateContext } from '../../contexts/ContextProvider';
import { toast } from 'react-toastify';
import Loading from '../../components/Loading';
import { DownloadTableExcel } from 'react-export-table-to-excel';
import { FaRegFileExcel } from 'react-icons/fa6';
import { LuFileSpreadsheet } from 'react-icons/lu';
import Swal from 'sweetalert2';
import MySelect from '../../components/MySelect';

const EtatAnnuelClasse = () => {
    const [errors, setErrors] = useState(null);
    const [items, setItems] = useState([]);
    const [inputValue, setValue] = useState('');
    const [selectedValue, setSelectedValue] = useState(null);
    const [loading, setLoading] = useState(false);
    const [factures, setFactures] = useState([]);

    const { token, setToken, user } = useStateContext();
    const tableRef = useRef();
    const [type, setType] = useState('');
    const [classes, setClasses] = useState([]);
    const [selectedClasse, setSelectedClasse] = useState(null);
    const [inputValueClasse, setValueClasse] = useState('');
    const [somme, setSomme] = useState({
        totalRest: 0,
        totalPayee: 0,


    })
    const [req, setReq] = useState({
        'scolaire': '',
        'classe': ''
    });
    const navigate = useNavigate();
    const getClasses = () => {
        axiosClient.get('/classes')
            .then((data) => {
                setClasses(data.data.classes);
            }).catch(err => {
                navigate('/500');
            })
    }

    const handleInputChangeClasse = value => {
        setValueClasse(value);
    };
    const handleChangeClasse = value => {
        setSelectedClasse(value);
        setReq({ ...req, classe: value.id });

    }
    // handle input change event

    const handleInputChange = value => {
        setValue(value);
    };

    // handle selection
    const handleChange = value => {
        setSelectedValue(value);
        setReq({ ...req, scolaire: value.id })

    }

    useEffect(() => {
        getScolaires();
        getClasses();
    }, []);



    const getScolaires = () => {
        axiosClient.get('/getScolaires')
            .then((data) => {
                setItems(data.data.scolaires);
            }).catch(err => {
                navigate('/500');
            })
    }



    const getFacture = () => {
        setType('');
        setLoading(true);
        if (selectedValue != null) {
            axiosClient.get('/etatAnnuelClasse/' + req.scolaire + '/' + req.classe,)
                .then(response => {
                    setFactures(response.data.etat.filter(o => o.total > 0));

                    setLoading(false);
                    setErrors(null);
                }).catch(err => {
                    const response = err.response;
                    if (response.status === 401) {
                        setToken(null);
                    }
                    else {
                        if (response.status === 422) {
                            setErrors(response.data.errors);
                            setLoading(false);
                            toast.error('Merci de verifier les informations a saisies!', {
                                position: "top-right",
                                autoClose: 5000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                                progress: undefined,
                                theme: "light",
                            });
                        } else {
                            if (response.status === 403) {
                                navigate('/403');
                            } else {
                                if (response.status === 404) {
                                    navigate('/404');
                                }
                                else {
                                    navigate('/500');
                                }
                            }
                        }

                    }
                })
        }

    }




    return (
        <>
            <Header icon={<LuFileSpreadsheet />} title="Etat Annuel de Classe" />
            {errors &&
                Object.keys(errors).map(key => (
                    <Alert key={key} message={errors[key][0]} />
                ))
            }
            <div className='flex gap-2 w-full flex-wrap md:flex-nowrap lg:flex-nowrap xl:flex-nowrap justify-between items-center'>

                <div className='mt-8 flex w-full gap-2' >
                    <div className=' w-full'>
                        <MySelect label="Année scolaire" placeholder="Année scolaire" cacheOptions defaultOptions value={selectedValue} getOptionLabel={e => e.code} getOptionValue={e => e.id} options={items} onInputChange={handleInputChange} onChange={handleChange} />
                    </div>
                    <div className="flex w-full gap-2">
                        <MySelect label="Classe" labelAr="القسم" placeholder="Classe" cacheOptions defaultOptions value={selectedClasse} getOptionLabel={e => e.libelle} getOptionValue={e => e.id} options={classes} onInputChange={handleInputChangeClasse} onChange={handleChangeClasse} />
                        <div className="mt-8">
                            <Button onClick={() => getFacture()} color="bg-yellow-500" icon={<IoIosSearch />} text="Chercher" textColor="text-white" />
                        </div>
                    </div>

                    <DownloadTableExcel
                        filename="Factures"
                        sheet="Factures"
                        currentTableRef={tableRef.current}
                    >
                        <Button color="bg-green-500" icon={<FaRegFileExcel />} size="20" text="Exporter" textColor="text-white" />

                    </DownloadTableExcel>
                </div>
            </div>

            <div className='flex gap-2 w-full flex-wrap md:flex-nowrap lg:flex-nowrap xl:flex-nowrap '>



            </div>
            <div className="flex my-2 gap-3">
                <h1 className='text-red-500 font-bold'>Total Reste: {factures.reduce((n, { reste }) => n + parseFloat(reste), 0)} MRU</h1>
                <h1 className='text-green-700 font-bold'>Total Payée: {factures.reduce((n, { payee }) => n + parseFloat(payee), 0)} MRU</h1>
            </div>
            <div className='flex mt-3 overflow-auto'>

                <table ref={tableRef} className='table-auto' >
                    <thead>
                        <tr>
                            <th>Elève</th>
                            <th>Description</th>
                            
                            <th>Classe</th>
                            
                            <th>Total</th>
                            <th>Dispense</th>
                            <th>Payée</th>
                            <th>Reste</th>
                            
                        </tr>
                    </thead>
                    {loading ? <tbody><tr className='content-center items-center'><td className='content-center items-center' colSpan="9"><Loading /></td></tr></tbody> :
                        <tbody>
                            {factures && factures.map(o => (
                                <tr className='hover:bg-gray-200' key={o.id}>
                                    <td>{o.inscription.eleve}</td>
                                    <td>{o.description}</td>
                                    <td>{o.inscription.classe.libelle}</td>
                                    <td>{o.total}</td>
                                    <td>{o.dispense}</td>
                                    <td>{o.payee}</td>
                                    <td>{o.total - o.dispense - o.payee}</td>
                                    
                                </tr>
                            ))

                            }
                        </tbody>

                    }

                </table>
            </div>

        </>
    )
}

export default EtatAnnuelClasse